'use client';

import { fleetApi } from '../api/axiosClient';

const endPoint = 'vehicle-license-detail';
const getTzParam = () => `?tz=${Math.abs(new Date().getTimezoneOffset() / 60)}`;

export const getVehicleLicenseDetailImage = async (id, type) => {
  if (id == null) throw new Error('id is required');
  try {
    const resp = await fleetApi.get(`/${endPoint}/images/${id}${getTzParam()}&imageType=${type}`);
    return resp?.data ?? null;
  } catch (err) {
    console.error('Failed to fetch vehicle license detail image:', err);
    throw err;
  }
};

export const deleteVehicleLicenseDetailImage = async (id, type, fileName) => {
  if (id == null) throw new Error('id is required');
  try {
    const response = await fleetApi.delete(`/${endPoint}/images/${id}${getTzParam()}&imageType=${type}&file=${fileName}`);
    return response.data;
  } catch (err) {
    console.error('Failed to delete vehicle license detail image:', err);
    throw err;
  }
};

export const uploadVehicleLicenseDetailFile = async (id, file, imageType) => {
  if (id == null) throw new Error('id is required');
  try {
    const fd = new FormData();
    fd.append('file', file);
    const response = await fleetApi.post(`/${endPoint}/uploadfile/${id}${getTzParam()}&imageType=${imageType}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  } catch (err) {
    console.error('Failed to upload vehicle license detail file:', err);
    throw err;
  }
};

export const getVehicleLicenseDetailFile = async (licenseDetailId, type) => {
  if (!licenseDetailId) throw new Error('licenseDetailId is required');
  if (!['front', 'back', 'document'].includes(type)) {
    throw new Error("type must be 'front', 'back', or 'document'");
  }
  try {
    const url = `/vehicle-license-detail/images/${licenseDetailId}?imageType=${type}`;
    const response = await fleetApi.get(url);
    const imageUrl = response.data?.data || response.data || '';
    return imageUrl;
  } catch (error) {
    console.error(`Error fetching vehicle license image ${type}:`, error?.response?.data ?? error);
    return '';
  }
};
